
(() => {
  const VINYL_IDS = new Set([
    9189000216832, // 7-inch
    9189044912384, // 10-inch
    9189049204992  // 12-inch
  ]);

  const MESSAGE =
    "Only one Side A + Side B vinyl recording program is allowed per checkout. " +
    "You can order multiple identical copies, but different recordings require separate orders.";

  let lastCheck = null;
  let validationMessage = MESSAGE;
  let lastCheckTime = 0;

  async function hasMultipleVinylLines() {
    // Briefly cache the result to avoid repeated requests.
    if (lastCheck !== null && Date.now() - lastCheckTime < 500) {
      return lastCheck;
    }

    const response = await fetch(
      (window.Shopify?.routes?.root || "/") + "cart.js",
      { credentials: "same-origin", cache: "no-store" }
    );

    if (!response.ok) throw new Error("Unable to read cart");

    const cart = await response.json();

    const vinylLines = cart.items.filter(item =>
      VINYL_IDS.has(Number(item.product_id))
    );

    validationMessage=MESSAGE;
    lastCheck=vinylLines.length>1;
    const orphan=cart.items.find(i=>i.properties?._LCVR_mastering_for&&!vinylLines.some(v=>v.properties?._LCVR_project===i.properties._LCVR_mastering_for));
    if(!lastCheck&&orphan){lastCheck=true;validationMessage='Remove the mastering add-on for the record you removed, or add that release again.';}
    if(!lastCheck)for(const item of vinylLines){
      const p=item.properties||{},one=Number(item.product_id)===9189044912384&&/single[ -]?sided/i.test(item.variant_title||''),entries=Object.entries(p).filter(([k,v])=>typeof v==='string'&&/^https:\/\//i.test(v)),audio=entries.filter(([,v])=>/\.(?:wav|aiff?)(?:[?#]|$)/i.test(v)),zips=entries.filter(([,v])=>/\.zip(?:[?#]|$)/i.test(v));
      const labeledA=audio.filter(([k])=>/side[ _-]*a/i.test(k)),labeledB=audio.filter(([k])=>/side[ _-]*b/i.test(k));
      const needsArtwork=/cnc|engrav|full[ -]*colou?r|jacket|label/i.test(item.variant_title||'');
      let error='';
      if(p['_Mastering songs']){
        const count=Number(p['_Mastering songs']),services=cart.items.filter(i=>Number(i.variant_id)===48978084266240&&i.properties?._LCVR_mastering_for===p._LCVR_project);
        if(!Number.isInteger(count)||count<1||count>10)error='The mastering song count is invalid. Rebuild this release.';
        else if(services.length!==1||services[0].quantity!==count)error='This release needs '+count+' vinyl mastering units, one per uploaded song. Restore the mastering quantity or return to the builder.';
        else if(!/^https:\/\/.*\.zip(?:[?#]|$)/i.test(p['_Mastering ZIP']||''))error='Upload the mastering songs ZIP before checkout.';
        else if(one&&!p['_Single-sided confirmation'])error='Confirm Side A only before checkout.';
        else if(needsArtwork&&!/^https:\/\/.*\.zip(?:[?#]|$)/i.test(p['Artwork ZIP']||p['_Artwork ZIP']||''))error='Upload the required artwork ZIP before checkout.';
      }
      else if(one&&!(p['_Single-sided confirmation']||p['Single-sided confirmation']))error='Confirm your single-sided record: Side A audio only.';
      else if(one&&audio.length!==1)error=audio.length?'Single-sided records need exactly one Side A audio file. Remove the extra Side B audio.':'Upload your Side A WAV or AIFF before checkout.';
      else if(one&&labeledB.length&&!labeledA.length)error='Your only attached audio is labeled Side B. Attach it as Side A for your single-sided record.';
      else if(!one&&(audio.length!==2||(labeledA.length&&labeledB.length===0)||(labeledB.length&&labeledA.length===0)))error='Upload both Side A and Side B WAV or AIFF files. Side A only is available on the 10-inch single-sided record.';
      else if(needsArtwork&&!zips.length)error='Upload the required artwork ZIP before checkout.';
      if(error){lastCheck=true;validationMessage=item.product_title+': '+error;break;}
    }
    lastCheckTime = Date.now();

    return lastCheck;
  }

  function showError() {
    let notice = document.getElementById("vinyl-cart-error");

    if (!notice) {
      notice = document.createElement("div");
      notice.id = "vinyl-cart-error";
      notice.setAttribute("role", "alert");

      Object.assign(notice.style, {
        position: "fixed",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: "2147483647",
        background: "#111",
        color: "#fff",
        padding: "20px",
        border: "1px solid #fff",
        borderRadius: "8px",
        maxWidth: "440px",
        width: "calc(100% - 40px)",
        textAlign: "center",
        boxShadow: "0 8px 30px #0006"
      });

      document.body.appendChild(notice);
    }

    notice.replaceChildren();

    const text = document.createElement("p");
    text.textContent = validationMessage;

    const close = document.createElement("button");
    close.type = "button";
    close.textContent = "Close";
    close.style.cssText =
      "margin-top:12px;padding:10px 20px;background:white;color:black;border:0;cursor:pointer;";
    close.addEventListener("click", () => notice.remove());

    notice.append(text, close);
  }

  function isCheckoutAction(element) {
    if (!(element instanceof Element)) return false;

    return Boolean(element.closest(
      'button[name="checkout"],' +
      'input[name="checkout"],' +
      'a[href*="/checkout"],' +
      'button[data-testid*="checkout"],' +
      '[data-checkout-button]'
    ));
  }

  // Intercept ordinary checkout button clicks.
  document.addEventListener("click", async event => {
    if (!isCheckoutAction(event.target)) return;

    // Stop the original click until the cart has been checked.
    event.preventDefault();
    event.stopImmediatePropagation();

    const target = event.target.closest(
      'button, input, a, [data-checkout-button]'
    );

    try {
      if (await hasMultipleVinylLines()) {
        showError();
        return;
      }

      // Continue to checkout when the cart is valid.
      window.location.assign(
        (window.Shopify?.routes?.root || "/") + "checkout"
      );
    } catch (error) {
      console.error("Vinyl cart guard:", error);
      alert("Unable to verify your cart. Please refresh and try again.");
    }
  }, true);

  // Intercept regular cart form submissions.
  document.addEventListener("submit", async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const submitter = event.submitter;
    const checkoutSubmission =
      submitter?.name === "checkout" ||
      /\/checkout(?:\?|$)/.test(form.action);

    if (!checkoutSubmission) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    try {
      if (await hasMultipleVinylLines()) {
        showError();
        return;
      }

      window.location.assign(
        (window.Shopify?.routes?.root || "/") + "checkout"
      );
    } catch (error) {
      console.error("Vinyl cart guard:", error);
      alert("Unable to verify your cart. Please refresh and try again.");
    }
  }, true);
})();

(()=>{let timer;const ids=new Set([9189000216832,9189044912384,9189049204992]);async function protectExpress(){try{const r=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});if(!r.ok)return;const c=await r.json();const hasRecords=c.items.some(i=>ids.has(Number(i.product_id)));document.querySelectorAll('shopify-accelerated-checkout-cart,.cart__additional-checkout-buttons').forEach(n=>{n.hidden=hasRecords;n.inert=hasRecords;if(hasRecords)n.style.setProperty('display','none','important');else n.style.removeProperty('display');});}catch(e){document.querySelectorAll('shopify-accelerated-checkout-cart,.cart__additional-checkout-buttons').forEach(n=>{n.hidden=true;n.inert=true;n.style.setProperty('display','none','important');});}}
function later(){clearTimeout(timer);timer=setTimeout(protectExpress,250);}new MutationObserver(later).observe(document.body,{childList:true,subtree:true});protectExpress();
})();

